<div class="content-wrapper container-xxl p-0" xmlns="http://www.w3.org/1999/html">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row">
      <!--DEAL DETAIL SECTION-->
      <section class="col-12" id="section2" *ngIf="!!deal">
        <div class="card" [ngClass]="activeTab === 'deal_detail' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('deal_detail')">
            <h3>{{ "DETAIL_OFFER_PRODUCT" | translate }}</h3>
          </div>
          <div [ngClass]="activeTab === 'deal_detail' ? 'card-body pb-0' : 'd-none'">
            <!--FORM DEAL DETAIL-->
            <div class="row" [formGroup]="formGroupDetail">
              <div class="col-12 my-1">
                <h4>{{ "CUSTOMER_INFORMATION" | translate }}</h4>
              </div>
              <div class="form-group col-12 col-xl-4">
                <label for="customer">{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="customer"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="customer"
                  [placeholder]="'PLACEHOLDER.SELECT_CUSTOMER' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('customer') ? 'is-invalid' : '' }}"
                  (change)="resetCustomerInformations($any($event))"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="customers_list"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.CUSTOMER_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-4">
                <label for="customer_site">{{ "OFFICE_SITE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="customer_site"
                  bindLabel="label"
                  bindValue="id"
                  formControlName="office_site"
                  [placeholder]="'PLACEHOLDER.SELECT_SITE' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [readonly]="!formGroupDetail.value.customer"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="filtered_customers_site_list"
                  class="{{ fieldHasErrors('office_site') ? 'is-invalid' : '' }}"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.INSERT_OFFICE_SITE" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-4">
                <div class="d-flex justify-content-between">
                  <label for="customer_referent">{{ "CUSTOMER_REFERENCE" | translate }}<sup class="text-danger">*</sup></label>
                  <label *ngIf="formGroupDetail.value.customer && _authService.hasCapability('create_customer_referent')" class="cursor-pointer text-primary" (click)="toggleModalAdd = true">{{
                    "ADD_NEW_CUSTOMER_REFERENCE" | translate
                  }}</label>
                </div>
                <ng-select
                  id="customer_referent"
                  bindLabel="complete_name"
                  bindValue="id"
                  formControlName="referent_id"
                  [placeholder]="'PLACEHOLDER.SELECT_REFERENT' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  [readonly]="!formGroupDetail.value.customer"
                  [clearable]="true"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="filtered_referents_list"
                ></ng-select>
              </div>
              <div class="col-12 my-1">
                <h4>{{ "DEAL_INFORMATION" | translate }}</h4>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
                <input class="form-control {{ fieldHasErrors('name') ? 'is-invalid' : '' }}" id="name" formControlName="name" [placeholder]="'PLACEHOLDER.INSERT_NAME' | translate" />
                <div class="invalid-feedback">{{ "ERRORS.FIELD_NAME" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="object">{{ "OBJECT" | translate }}<sup class="text-danger">*</sup></label>
                <input class="form-control {{ fieldHasErrors('object') ? 'is-invalid' : '' }}" id="object" formControlName="object" />
                <div class="invalid-feedback">{{ "ERRORS.INSERT_OBJECT" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="product">{{ "PRODUCTS" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="product"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="product"
                  [hideSelected]="true"
                  [placeholder]="'PLACEHOLDER.SELECT_ONE_OR_MORE_PRODUCT' | translate"
                  [multiple]="true"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('product') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="productsList"
                  (change)="fillDataTableProductsArray()"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.PRODUCTS_REQUIRED" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-6">
                <label for="commercial">{{ "CUSTOMER_COMMERCIAL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="commercial"
                  bindLabel="complete_name"
                  bindValue="hash"
                  formControlName="commercial"
                  [placeholder]="'PLACEHOLDER.SELECT_COMMERCIAL' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('commercial') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="commercial_list"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.INSERT_COMMERCIAL" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-3">
                <div class="d-flex justify-content-between">
                  <label for="start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
<!--                  <button (click)="clearDate()" [ngbTooltip]="'CLEAR_DATE' | translate" class="bg-transparent border-0 text-danger remove-item mb-025">-->
<!--                    <i [data-feather]="'trash-2'" size="15"></i>-->
<!--                  </button>-->
                </div>
                <app-datepickr id="start_date" (onSelect)="takeDate($event, 'start_date'); calculateDifferenceInMonth()" [defaultDate]="formGroupDetail.value.start_date"></app-datepickr>
              </div>
              <div class="form-group col-12 col-xl-3">
                <div class="d-flex justify-content-between">
                  <label for="end_date">{{ "END_DATE" | translate }}<sup class="text-danger">*</sup></label>
<!--                  <button (click)="clearDate()" [ngbTooltip]="'CLEAR_DATE' | translate" class="bg-transparent border-0 text-danger remove-item mb-025">-->
<!--                    <i [data-feather]="'trash-2'" size="15"></i>-->
<!--                  </button>-->
                </div>
                <app-datepickr
                  id="end_date"
                  (onSelect)="takeDate($event, 'end_date'); calculateDifferenceInMonth()"
                  [defaultDate]="formGroupDetail.value.end_date"
                  [isInvalid]="!formGroupDetail.value.end_date && showErrors"
                ></app-datepickr>
              </div>
              <div class="form-group col-12 col-xl-3">
                <label for="billing_frequency">{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select
                  id="billing_frequency"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="billing_frequency"
                  [placeholder]="'PLACEHOLDER.SELECT_BILLING_FREQUENCY' | translate"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ fieldHasErrors('billing_frequency') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="billingFrequencyList"
                  (change)="calculateDifferenceInMonth()"
                ></ng-select>
                <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
              </div>
              <div class="form-group col-12 col-xl-3">
                <label for="tranche_number">{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input
                  class="form-control {{ fieldHasErrors('tranche_number') || formGroupDetail?.value?.tranche_number === 0 ? 'is-invalid' : '' }}"
                  id="tranche_number"
                  [placeholder]="'PLACEHOLDER.INSERT_TRANCHE_NUMBER' | translate"
                  type="number"
                  formControlName="tranche_number"
                />
                <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_NUMBER" | translate }}</div>
              </div>
            </div>
            <!--END FORM DEAL DETAIL-->
          </div>
        </div>
      </section>

      <!--DEAL PREVENTIVE SECTION-->
      <section class="col-12 section3" *ngIf="isDetailSectionCompleted">
        <div class="card" [ngClass]="activeTab === 'deal_document' ? 'active' : ''" [formGroup]="formGroupBoxes">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('deal_document')">
            <h3>{{ "DEAL_DOCUMENT" | translate }}</h3>
          </div>
          <div [ngClass]="activeTab === 'deal_document' ? 'card-body pb-0' : 'd-none'">
            <!--BOX 1-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>1. {{ "SUPPLY_DESCRIPTION" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_1" [formControlName]="'box_1'"></textarea>
              </div>
            </div>
            <!--Box 2-->
            <div class="row">
              <div [class]="'form-group col-12'">
                <h4>2. {{ "ECONOMIC_OFFER" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_2" [formControlName]="'box_2'"></textarea>
                <p class="font-small-3">{{ "LEGEND_TABLECONTENT" | translate }}</p>
                <!-- DATA TABLE -->
                <div class="card-body px-0 pb-0">
                  <table class="tg col-12">
                    <thead>
                      <tr>
                        <th class="tg-0lax">
                          {{ "DESCRIPTION" | translate }}
                          <span class="cursor-pointer" (click)="columnTable.description = false" *ngIf="columnTable?.description" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.description = true" *ngIf="!columnTable?.description" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "PERIOD" | translate }}
                          <span class="cursor-pointer" (click)="columnTable.period = false" *ngIf="columnTable?.period" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.period = true" *ngIf="!columnTable?.period" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "QUANTITY" | translate }}
                          <span class="cursor-pointer" (click)="columnTable.quantity = false" *ngIf="columnTable?.quantity" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.quantity = true" *ngIf="!columnTable?.quantity" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "PRODUCT" | translate }} <sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTable.product_name = false" *ngIf="columnTable?.product_name" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.product_name = true" *ngIf="!columnTable?.product_name" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "PRICE" | translate }}<sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTable.price = false" *ngIf="columnTable?.price" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate"
                            ><i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.price = true" *ngIf="!columnTable?.price" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "SINGLE_AMOUNT" | translate }}<sup class="text-white">*</sup>
                          <span class="cursor-pointer" (click)="columnTable.line_amount = false" *ngIf="columnTable?.line_amount" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate"
                            ><i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.line_amount = true" *ngIf="!columnTable?.line_amount" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">
                          {{ "DISCOUNTED_AMOUNT" | translate }}
                          <span class="cursor-pointer" (click)="columnTable.discount = false" *ngIf="columnTable?.discount" [ngbTooltip]="'COLUMNS_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye'" size="19"></i
                          ></span>
                          <span class="cursor-pointer" (click)="columnTable.discount = true" *ngIf="!columnTable?.discount" [ngbTooltip]="'COLUMNS_NOT_SHOWED_TABLE' | translate">
                            <i class="ml-025 text-white" [data-feather]="'eye-off'" size="19"></i
                          ></span>
                        </th>
                        <th class="tg-0lax">{{ "ACTIONS" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of tablesRows; let i = index">
                        <td class="text-center">{{ row.description }}</td>
                        <td class="text-center">{{ row.period }}</td>
                        <td class="text-center">{{ row.quantity }}</td>
                        <td class="text-center">{{ row.product_name }}</td>
                        <td class="text-center"><span *ngIf="row.price">€. </span>{{ row.price }}</td>
                        <td class="text-center"><span *ngIf="row.line_amount">€. </span>{{ row.line_amount }}</td>
                        <td class="text-center"><span *ngIf="row.discount">€. </span>{{ row.discount }}</td>
                        <td class="text-center">
                          <div>
                            <button (click)="modalOpen(modal, row, i)" type="button" class="btn btn-circle btn-sm" rippleEffect>
                              <i class="ml-025 text-primary" [data-feather]="'edit-2'" size="19"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="text-right mt-1" *ngIf="tablesRows && tablesRows.length >= 1">
                    <div *ngIf="tablesRows[0].total_deal">
                      <strong>{{ "TOTAL_SINGULAR" | translate }}: </strong> <span>€. </span>{{ tablesRows[0].total_deal }}
                    </div>
                    <div *ngIf="tablesRows[0].total_discounted_deal">
                      <strong>{{ "TOTAL_DISCOUNTED_AMOUNT" | translate }}: </strong> <span>€. </span>{{ tablesRows[0].total_discounted_deal }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Box 3-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>3. {{ "JOB_SITE_AND_TIMETABLES" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_3" [formControlName]="'box_3'"></textarea>
              </div>
            </div>
            <!--Box 4-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>4. {{ "LEGAL_OBLIGATIONS" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_4" [formControlName]="'box_4'"></textarea>
              </div>
            </div>
            <!--Box 5-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>5. {{ "PRIVACY" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_5" [formControlName]="'box_5'"></textarea>
              </div>
            </div>
            <!--Box 6-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>6. {{ "FACTURATION_MODE" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_6" [formControlName]="'box_6'"></textarea>
              </div>
            </div>
            <!--Box 7-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>7. {{ "PAYAMENT_TERMS" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_7" [formControlName]="'box_7'"></textarea>
              </div>
            </div>
            <!--Box 8-->
            <div class="row mb-1">
              <div [class]="'form-group col-12'">
                <h4>8. {{ "VALID_OFFFER" | translate }}</h4>
                <textarea class="form-control" rows="5" id="box_8" [formControlName]="'box_8'"></textarea>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- MANAGE DOCUMENTATION -->
      <section class="col-12 section3" *ngIf="deal && isDetailSectionCompleted && _authService.hasCapability('manage_deal_document')">
        <div class="card" [ngClass]="activeTab === 'MANAGE_DOCUMENT' ? 'active' : ''">
          <!--TITLE-->
          <div class="card-title px-2 mb-0" (click)="changeTab('manage_document')">
            <h3>{{ "MANAGE_DOCUMENT" | translate }}</h3>
          </div>
          <div [ngClass]="activeTab === 'manage_document' ? 'card-body pb-0' : 'd-none'">
            <!--Upload Document-->
            <div class="row">
              <div class="col-12 col-xl">
                <label for="file-uploader">{{ "INSERT.UPLOAD_DOCUMENT" | translate }}:</label>
                <div id="file-uploader" class="custom-file mb-2" *ngIf="!completedFileUpload">
                  <input
                    class="custom-file-input"
                    type="file"
                    lang="it"
                    id="file"
                    [multiple]="false"
                    (change)="handlerChangeFileInput($any($event).target.files)"
                    accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                  <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                  <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                  <p class="font-small-3 text-muted" *ngIf="!!deal.deal_document.document_url">{{ "UPLOAD_DEAL_MESSAGE" | translate }}</p>
                </div>
                <p class="text-success" *ngIf="completedFileUpload">
                  <i [data-feather]="'check'" size="19"></i>
                  {{ "ALERT.SUCCESS_UPLOAD_FILE" | translate }}
                </p>
                <button class="btn btn-outline-success" *ngIf="dealDocument && !completedFileUpload" (click)="uploadDocument()">{{ "UPLOAD" | translate }}</button>
              </div>
              <div class="col-12 col-xl-8 my-2 d-flex align-items-center">
                <button class="btn btn-outline-primary mr-1" (click)="_utilService.getFile(deal.deal_document.document_url)" *ngIf="!!deal.deal_document.document_url">
                  {{ "VIEW_FILE_DOCUMENT" | translate }}
                </button>
                <button class="btn btn-outline-primary mr-1" (click)="downloadDocument()" *ngIf="deal.deal_document.document_url">
                  {{ "DOWNLOAD_DOCUMENT" | translate }}
                </button>
                <button *ngIf="_authService.hasCapability('manage_deal_document') && !deal.deal_document.document_url" class="btn btn-outline-primary" (click)="generateDocument()">
                  {{ "GENERATE_PDF_DOCUMENT" | translate }}
                </button>
                <button *ngIf="_authService.hasCapability('manage_deal_document') && !!deal.deal_document.document_url" class="btn btn-outline-primary" (click)="regenerateDocument()">
                  {{ "REGENERATE_DOCUMENT" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="row" *ngIf="isDetailSectionCompleted && _authService.hasCapability('edit_deal')">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary text-primary mb-4" (click)="edit()">{{ "SAVE" | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #modal let-modal>
  <form [formGroup]="formGroupTable">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ADD_ROW_TABLE" | translate }}</h3>
      <div class="row">
        <div class="form-group col-12">
          <label for="product_id">{{ "PRODUCT" | translate }}<sup class="text-danger">*</sup></label>
          <select class="form-control" id="product_id" formControlName="product_id">
            <option [value]="product.id" *ngFor="let product of products_list_datatable">{{ product.name }}</option>
          </select>
        </div>
        <div class="form-group col-12">
          <label for="description">{{ "DESCRIPTION" | translate }}</label>
          <textarea id="description" [placeholder]="'SHORT_DESCRIPTION' | translate" type="text" class="form-control" rows="4" formControlName="description"></textarea>
        </div>
        <div class="form-group col-12">
          <label for="period">{{ "PERIOD" | translate }}</label>
          <input id="period" type="text" class="form-control" formControlName="period" />
        </div>
        <div class="form-group col-12">
          <label for="price">{{ "PRICE" | translate }}<sup class="text-danger">*</sup></label>
          <input id="price" placeholder="100,00" type="text" class="form-control" formControlName="price" (change)="formatMoneyValue($any($event.target).value, 'price')" />
        </div>
        <div class="form-group col-12">
          <label for="quantity">{{ "QUANTITY" | translate | titlecase }}<sup class="text-danger">*</sup></label>
          <input id="quantity" placeholder="1" type="number" class="form-control" min="1" formControlName="quantity" (change)="calculateLineAmount(formGroupTable.value.price)" />
        </div>
        <div class="form-group col-12">
          <label for="line_amount">{{ "AMOUNT" | translate }}<sup class="text-danger">*</sup></label>
          <input id="line_amount" placeholder="3.000,00" type="text" class="form-control" formControlName="line_amount" (change)="formatMoneyValue($any($event.target).value, 'line_amount')" />
        </div>
        <div class="form-group col-12">
          <label for="discount">{{ "DISCOUNTED_AMOUNT" | translate }}</label>
          <input id="discount" placeholder="1.500,00" type="text" class="form-control" formControlName="discount" (change)="formatMoneyValue($any($event.target).value, 'discount')" />
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect>
        {{ "BACK" | translate }}
      </button>
      <button type="button" class="btn btn-primary w-150" (click)="editRow()" rippleEffect>
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal -->

<!-- Modal ADD -->
<app-form-add-customer-referent
  *ngIf="toggleModalAdd && _authService.hasCapability('create_customer_referent')"
  (callbackFn)="toggleModalAdd = false"
  (onAdd)="onReferentModalFormEvent($event)"
  [clientID]="formGroupDetail.value.customer"
></app-form-add-customer-referent>
<!-- / Modal ADD -->
